<script setup>
import Vue, {reactive, ref} from "vue";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import needsService from "@/services/needs.service";

const showModal = ref(false);
const loading = ref(false);

const form = reactive({
    comment: ''
});

function open() {
    form.comment = '';
    showModal.value = true;
}

async function send() {
    loading.value = true;
    const {data} = await needsService.sendFindMoreSolutionsRequest(form);

    if (data) {
        showModal.value = false;

        Vue.notify({
            group: 'app',
            type: 'success',
            duration: 3000,
            text: "Request Sent"
        })
    }

    loading.value = false;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" title="Find More Solutions Request" modal-class="modal-primary">
        <p>Supercharge your innovation lifecycle by tapping into SwitchPitch’s full feature set:</p>

        <ul class="list-upgrade">
            <li class="list-upgrade__startup">Search over 650,000 startups</li>
            <li class="list-upgrade__ecosystem">50+ VC, accelerator and incubator partners</li>
            <li class="list-upgrade__tool">Custom diligence assessment tools</li>
            <li class="list-upgrade__tracker">Unlimited projects</li>
            <li class="list-upgrade__reporting">Dashboards & AI reporting</li>
        </ul>

        <template #modal-footer>
            <form class="form">
                <div class="form__item">
                    <b-form-textarea
                        v-model="form.comment"
                        class="form-control--mid mb-3"
                        placeholder="Add a note (optional)"
                    />
                </div>

                <div class="text-center">
                    <PrimaryButton
                        caption="Request to Find More Solutions"
                        :loading="loading"
                        @click="send"
                        class="btn-xl btn-xl-request"
                    />
                </div>
            </form>
        </template>
    </b-modal>
</template>

<style scoped>

</style>
